import { TextProps } from '@chakra-ui/react';
import { Maybe } from '@monetize/types/common';
import {
  TIMEZONE_CONFIG,
  toDateShort,
  toDateTimeShort,
} from '@monetize/utils/core';
import isDate from 'lodash/isDate';
import isString from 'lodash/isString';
import { useGetTimezones } from '../../../api/timezoneService';
import { MText, MTooltip } from '../../Monetize';

interface QuoteStepDateProps {
  /**
   * The value to display.
   */
  dateString: Maybe<string | Date>;
  textProps: TextProps;
}

/**
 * Display a date or datetime value with a tooltip showing the timezone.
 */
export const QuoteStepDate = ({
  dateString,
  textProps,
}: QuoteStepDateProps) => {
  const { data: timeZones } = useGetTimezones();

  if (!dateString || (!isString(dateString) && !isDate(dateString))) {
    return null;
  }

  const dateValue = toDateShort(dateString, 'userTimezone');
  const dateTimeValue = toDateTimeShort(dateString, 'userTimezone');

  // Short code such as "PT" for Pacific Time instead of America/Los_Angeles
  const timeZoneLabel =
    timeZones?.timezonesByValue[TIMEZONE_CONFIG.userTimezone]?.label;

  return (
    <MTooltip openDelay={500} label={`${dateTimeValue} ${timeZoneLabel}`}>
      <MText {...textProps}>{dateValue}</MText>
    </MTooltip>
  );
};
